import axiosInstance from '@/api/axiosInstance';
import { globalState } from '@/globalState';

function safeTrim(value) {
  if (value === undefined || value === null) {
    return '';
  }
  return String(value).trim();
}

function clearAuthCookies() {
  if (typeof document === 'undefined') {
    return;
  }
  const sameSiteLax = (process.env.environment === 'production') ? '; SameSite=Lax' : '';
  document.cookie = `jwtToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${sameSiteLax}`;
  document.cookie = `authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${sameSiteLax}`;
  document.cookie = `userData=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${sameSiteLax}`;
}

function isAuthExpiredError(error) {
  const status = error?.response?.status;
  if (status === 401 || status === 403) {
    const message = safeTrim(error?.response?.data?.message) || safeTrim(error?.response?.data?.error) || safeTrim(error?.message);
    const lower = message.toLowerCase();
    if (lower.includes('jwt expired') === true) {
      return true;
    }
    return true;
  }
  return false;
}

function getApiBaseUrl() {
  const fromState = globalState !== undefined && globalState !== null ? globalState.apiEndpoint : '';
  if (typeof fromState === 'string' && fromState.trim().length > 0) {
    return fromState.trim().replace(/\/+$/, '');
  }
  const raw = typeof process !== 'undefined' && process.env !== undefined && process.env !== null ? process.env.VUE_APP_API_URL : '';
  if (typeof raw === 'string' && raw.trim().length > 0) {
    return raw.trim().replace(/\/+$/, '');
  }
  return '';
}

function isAbsoluteHttpUrl(value) {
  if (typeof value !== 'string') {
    return false;
  }
  const v = value.trim();
  if (v.startsWith('http://') === true) {
    return true;
  }
  if (v.startsWith('https://') === true) {
    return true;
  }
  return false;
}

export async function fetchUserData() {
  const base = getApiBaseUrl();
  const normalizedBase = typeof base === 'string' ? base.trim().replace(/\/+$/, '') : '';
  const isAbsolute = isAbsoluteHttpUrl(normalizedBase) === true;
  const url = isAbsolute === true
    ? (normalizedBase.endsWith('/api') === true ? `${normalizedBase}/users/userData` : `${normalizedBase}/api/users/userData`)
    : '/api/users/userData';
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    if (isAuthExpiredError(error) === true) {
      globalState.userInfo = null;
      clearAuthCookies();
      return null;
    }
    throw error;
  }
}

export async function logoutSession() {
  const base = getApiBaseUrl();
  const normalizedBase = typeof base === 'string' ? base.trim().replace(/\/+$/, '') : '';
  const isAbsolute = isAbsoluteHttpUrl(normalizedBase) === true;
  const url = isAbsolute === true
    ? (normalizedBase.endsWith('/api') === true ? `${normalizedBase}/users/logout` : `${normalizedBase}/api/users/logout`)
    : '/api/users/logout';
  try {
    await axiosInstance.post(url);
  } catch (e) {}
}








